module.exports = __webpack_public_path__ + "static/img/china-bg.2fc7b62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-bg.png
// module id = 1388
// module chunks = 1